"use client";

import { UserPlusIcon } from "lucide-react";

import { Routes } from "@/api";
import { toast } from "sonner";

import { seo } from "@/config/seo";
import { useIsDesktop } from "@/hooks/layout/use-is-desktop";
import { useSession } from "next-auth/react";
import { redirect, RedirectType } from "next/navigation";
import { DropdownMenuItem } from "../ui/dropdown-menu";

const config = {
  label: "Invite friends",
  modalTitle: "Invite via",
};

interface Props {
  readonly textHidden?: boolean;
  readonly code: string;
}

export function UserInvite(props: Props) {
  const isDesktop = useIsDesktop();
  const { data: session, status } = useSession();

  if (!session) {
    if (status === "unauthenticated") {
      redirect(Routes.AUTHENTICATION, RedirectType.replace);
    }
    return null;
  }

  const shareProfile = async () => {
    const url = seo.referral.link(session.user.id, props.code);

    if (navigator.share && !isDesktop) {
      try {
        await navigator.share({
          title: seo.referral.title,
          url,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      await navigator.clipboard?.writeText(url);
      toast.info("Invite copied to clipboard");
    }
  };

  return (
    <DropdownMenuItem className="gap-2" onClick={shareProfile}>
      <UserPlusIcon className="size-4" />
      {!props.textHidden ? config.label : ""}
    </DropdownMenuItem>
  );
}

// function ShareProfile(
//   props: Props & {
//     onShareProfileCb: () => void;
//   },
// ) {
//   const { data: session } = useSession();
//   const isDesktop = useIsDesktop();

//   const shareProfile = async () => {
//     const params = new URLSearchParams();
//     if (props.affiliateCode) {
//       params.set(Cookies.affiliate, props.affiliateCode);
//     }

//     const url =
//       params.size > 0 ? `${props.url}?${params.toString()}` : props.url;

//     if (navigator.share && !isDesktop) {
//       try {
//         await navigator.share({
//           title: inviteTemplate.title,
//           text: inviteTemplate.text,
//           url,
//         });
//       } catch (error) {
//         console.error("Error sharing:", error);
//       }
//     } else {
//       await navigator.clipboard?.writeText(url);
//       toast.info("Invite copied to clipboard");
//     }

//     props.onShareProfileCb();
//   };

//   return (
//     <div className="grid place-items-center gap-1 px-2">
//       <Share url={props.url} title={inviteTemplate.text} />
//       <span className="grid place-items-center">
//         <Button
//           onClick={shareProfile}
//           variant={"secondary"}
//           gtmEvent={{
//             userId: session?.user.id ?? "anonymous",
//             event: "share_profile",
//             eventCategory: "share_profile",
//             eventAction: "share",
//             eventLabel: `user_id:${session?.user.id ?? "anonymous"};url:${props.url}`,
//           }}
//         >
//           <Link className="mr-2 size-4" />
//           Copy Link
//         </Button>
//       </span>
//     </div>
//   );
// }
